module.exports = __webpack_public_path__ + "assets/images_base/bt-button-twitter.svg?v=4d3f66b9";